var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('img',_vm._g({staticClass:"medicine-pbm-badge",staticStyle:{"width":"33px","height":"33px"},attrs:{"src":"/img/icons/percentage.svg","alt":"Imagem de porcentagem"}},on))]}}])},[_c('span',{staticClass:"inter text-bold",staticStyle:{"color":"#000"}},[_vm._v("PBM")])])}
var staticRenderFns = []

export { render, staticRenderFns }